"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FWErrorsEnum = void 0;
var FWErrorsEnum;
(function (FWErrorsEnum) {
    FWErrorsEnum[FWErrorsEnum["ERROR_FLAT_BATTERY"] = 0] = "ERROR_FLAT_BATTERY";
    FWErrorsEnum[FWErrorsEnum["ERROR_BLE_LINK_LOSS"] = 1] = "ERROR_BLE_LINK_LOSS";
    FWErrorsEnum[FWErrorsEnum["ERROR_NOT_ENOUGH_MEMORY"] = 2] = "ERROR_NOT_ENOUGH_MEMORY";
    FWErrorsEnum[FWErrorsEnum["ERROR_PREVALIDATION"] = 3] = "ERROR_PREVALIDATION";
    FWErrorsEnum[FWErrorsEnum["ERROR_POSTVALIDATION"] = 4] = "ERROR_POSTVALIDATION";
    FWErrorsEnum[FWErrorsEnum["ERROR_DEVICE_DISCONNECTED"] = 5] = "ERROR_DEVICE_DISCONNECTED";
    FWErrorsEnum[FWErrorsEnum["ERROR_GENERAL"] = 6] = "ERROR_GENERAL";
})(FWErrorsEnum = exports.FWErrorsEnum || (exports.FWErrorsEnum = {}));
